/* eslint-disable max-len */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { privacy_policy_content as privacy_policy_content_en } from './privacy_policy_en';
import { privacy_policy_content as privacy_policy_content_am } from './privacy_policy_am';

const resources = {
  en: {
    translation: {
      top_selling_products: 'Top Selling Products',
      new_arrivals: 'New Arrivals',
      companies: 'Companies',
      similar_products: 'Similar Services',
      buy: 'Buy',
      submit: 'Submit',
      apply: 'Apply',
      cancel: 'Cancel',
      view_more: 'View More',
      amd: 'AMD',
      price: 'Price',
      bonus: 'bonus',
      generate_qr: {
        sender_name: 'Sender Name',
        sender_email: 'Sender Email',
        sender_phone_number: 'Sender Phone Number',
        personal: 'Personal',
        recipient_name: 'Recipient Name',
        recipient_email: 'Recipient Email',
        message: 'Message',
        notify_at: 'Notify At',
        gift: 'Gift',
        for_me: 'For me',
        send_now: 'Send now',
        schedule: 'Schedule',
        recipient_phone_number: 'Recipient Phone Number',
        is_anonymous: 'Anonymous',
      },
      create_gift_card: 'Create Gift Card',
      home: 'Home',
      type: 'Type',
      event: 'Event',
      events: 'Events',
      relationships: 'Relationships',
      description: 'Description',
      company_info: 'Company info',
      company: 'Company',
      address: 'Address',
      phone: 'Phone',
      sign_up: 'Sign Up',
      sign_in: 'Sign In',
      alrady_have_an_account: 'Alrady have an Account?',
      create_account: 'Create Account',
      name: 'Name',
      email: 'Email',
      quantity: 'Quantity',
      created_at: 'Created At',
      password: 'password',
      repeat_password: 'Repeat password',
      dont_have_an_account: 'Don’t have an account?',
      forgot_password: 'Forgot password',
      log_out: 'Log Out',
      are_you_sure_logout: 'Are you sure you want to log out?',
      main_menu: 'Main Menu',
      sent_gift_cards: 'Sent Gift Cards',
      sent: 'Sent',
      received: 'Received',
      received_gift_cards: 'Received Gift Cards',
      show: 'Show',
      gift_card: 'Gift Card',
      code: 'Code',
      expires_at: 'Expires At',
      profile: 'Profile',
      hero: {
        eyebrow: 'The first digital gift card platform in Armenia',
        title: 'Pick a gift card. Send it by email or SMS.',
        subtitle:
          'Gift cards from companies across Armenia. Choose the design, write a message, and it arrives by email or SMS — right away or on the day you choose.',
        primary_cta: 'Browse gift cards',
        secondary_cta: 'See the companies',
        proof_speed: 'Pick a design, write a message, and send it by email or SMS — right away or on a date you choose.',
        proof_partners: 'Pay with iDram or a Visa/Mastercard card. Some partners add a bonus you can spend on your next card.',
        proof_valid: 'The recipient gets a gift card with a code and QR to show at the partner company.',
        chip_delivery: 'Email or SMS',
        chip_pay: 'iDram · Visa/Mastercard',
        chip_redeem: 'Code and QR',
        art_alt: 'A gift card is paid for, sent by email or SMS, and shown at the partner as a code and QR.',
      },
      sold_cards_lead: 'gift cards sold so far',
      sold_cards_body:
        'Each one was bought on egiftcards.am and sent by email or SMS.',
      newsletter_body: 'Get news about new companies and offers by email.',
      faq_lead: 'Answers to common questions.',
      search: 'Search',
      menu: 'Menu',
      contact_lead: 'Write to us in the chat or by email. We answer on working days.',
      become_a_partner_lead:
        'Tell us about your company and we will get in touch about listing your gift cards.',
      request_company_lead: 'Is a company missing? Tell us which one and we will reach out to them.',
      close: 'Close',
      filters: 'Filters',
      clear_filters: 'Clear filters',
      no_results: 'No gift cards match these filters',
      read_more: 'Read more',
      view_all: 'View all',
      sold_cards: 'Sold Gift Cards',
      sort_by: 'Sort',
      price_desc: 'Price Desc',
      price_asc: 'Price Asc',
      become_a_partner: 'Become a Partner',
      partnership: 'Partnership',
      request_company: 'Request Company',
      first_name: 'First Name',
      last_name: 'Last Name',
      company_name: 'Company Name',
      send_request: 'Send a Request',
      contact: 'Contact',
      service: 'Service',
      order_number: 'Order Number',
      used_at: 'Used At',
      used: 'Used',
      not_used: 'Not used',
      download: 'Download',
      new_gift_card: 'New Gift Card',
      pay: 'Pay',
      continue: 'Continue',
      summary: 'Summary',
      e_gift_cards: 'E-Gift Cards',
      payment_successful: 'Payment Successful!',
      payment_message: "We're glad to inform you that we have confirmed your payment. Thank you!",
      payment_failed: 'Payment Failed',
      payment_failed_message: 'Your payment has not been received',
      yes: 'Yes',
      no: 'No',
      about_us: 'About Us',
      about_us_description: {
        title: 'Digital Gift-Cards Platform',
        convenience: 'Convenience',
        speed: 'Speed',
        variety: 'Variety',
        security: 'Security',
        lede: 'An online platform for buying and selling digital gift cards — for buyers and for the companies behind the cards.',
        what_title: 'What is E-Gift Cards?',
        what_body_1:
          'E-Gift Cards is an innovative online platform for buying and selling digital gift cards. We provide a convenient online platform for both buyers and sellers, revolutionizing the way people give and receive gift cards.',
        what_body_2:
          'We understand the importance of finding the perfect gift for your loved ones. Through our platform, you get access to a wide selection of digital gift cards from Armenian brands. Whether you are looking for a birthday gift, a holiday gift, or just want to make your loved ones happy, you will find it easily on our platform.',
        fact_delivery_label: 'Delivery',
        fact_delivery_value: 'Email or SMS',
        fact_payments_label: 'Payments',
        fact_payments_value: 'iDram, Visa/Mastercard',
        fact_brands_label: 'Brands',
        fact_brands_value: 'Armenian companies, large and small',
        why_title: 'Why choose E-Gift Cards?',
        why_lede: 'Four things we hold ourselves to, on every card sold on the platform.',
        convenience_body:
          'Our platform eliminates the need for physical gift cards by offering digital gift cards that are accessible from anywhere, anytime.',
        speed_body:
          'You no longer need to visit a store to buy a gift card. Get access to a large selection of gift cards, on one platform, and buy without leaving your home, at any time, in any country.',
        variety_body:
          'We have a huge collection of gift cards, which includes a wide variety of gift cards from well-known brands and small companies.',
        security_body:
          'We prioritize the security of your transactions by implementing robust security measures and encryption protocols. All gift cards are unique and cannot be copied.',
        join_title: 'Join E-Gift Cards today',
        join_body:
          'Enjoy the convenience and flexibility of digital gift card shopping. Whether you are a buyer or a seller, we strive to provide a safe and enjoyable platform that enhances the gifting experience for all involved.',
      },
      how_it_works: 'How It Works',
      contact_us: 'Contact Us',
      online_business: 'Armenia — online only',
      online_business_note:
        'We are an online business operating in Armenia. We have no physical store or office — reach us in the chat or by email.',
      live_chat: 'Live chat',
      start_chat: 'Start a chat',
      where_we_work: 'Where we work',
      online_gift_cards: 'E-Gift Cards',
      services: 'Services',
      gift_cards: 'Gift Cards',
      soon: 'Soon',
      showing_results: 'Showing {{firstItemNumber}}-{{lastItemNumber}} of {{total}} results',
      gift_card_is_valid_for: 'Gift Card is valid for {{expiresAt}} days',
      online: 'Online',
      sorry_page_not_found: 'Sorry, We can’t Find that page...',
      back_to_home: 'Back to Home',
      phone_number: 'Phone number',
      balance: 'Balance',
      messages: {
        become_a_partner_success: 'Your request has been successfully received!',
      },
      attention: 'Attention!',
      enter_your_phone_number: 'Enter your phone number for verification',
      preview: 'Preview',
      share: 'Share This',
      available_bonus: 'Available Bonus',
      privacy_policy: 'Privacy policy',
      terms_of_service: 'Terms of service',
      agree_with_policy: `I have read and agree to the <privacyPolicy>Privacy policy</privacyPolicy>
        {{and}}<termsOfService>Terms of service</termsOfService>`,
      and: 'and',
      special_offers: 'Special offers',
      learn_more: 'Learn more',
      buyers_passport: 'Buyer’s passport',
      upload_images: 'Upload Images',
      coupon: 'Coupon',
      search_company: 'Search Company',
      name_desc: 'By name Z-A',
      name_asc: 'By name A-Z',
      starting_from: 'Starting from',
      all_companies: 'Show All',
      latest_companies: 'Latest Companies',
      faq: 'Frequently Asked Questions',
      blog: 'Blog',
      blog_description: 'Gift ideas, tips and news from egiftcards.am',
      no_articles_found: 'There are no articles yet.',
      newsletter_subscription: 'Subscribe to our newsletter',
      support: 'Support',
      creating: {
        title: 'Choose and pay',
        description:
          'Pick a gift card, choose its design, add a message for the recipient and pay with iDram or a Visa/Mastercard card.',
      },
      receiving: {
        title: 'Delivered by email or SMS',
        description:
          'The card goes out as a PDF by email or as a link by SMS — right after payment, or on the date you set.',
      },
      happiness: {
        title: 'Redeemed at the partner',
        description:
          'The recipient shows the card’s code or QR at the partner company, which checks it and marks it as used.',
      },
      delete: 'Delete',
      edit: 'Edit',
      event_calendar: {
        title: 'Title',
        description: 'Description',
        not_chosen: 'Not chosen',
        remind: {
          title: 'Remind',
          day: '1 day before',
          week: '1 week before',
          month: '1 month before',
        },
        repeat: {
          title: 'Repeat',
          day: 'Every day',
          month: 'Every month',
          year: 'Every year',
        },
        celebrant_name: 'Celebrant name',
        celebrant_email: 'Celebrant email',
        new_event: 'New Event',
      },
      privacy_policy_content: privacy_policy_content_en,
      date: 'Date',
      coupons: 'Coupons',
      website: 'Website',
      notes: 'Additional Info',
      sale: 'Sale',
      in_sale: 'Sale',
      multiple_recipients: 'Multiple Recipients',
      upload: 'Upload',
      upload_multiple_recipients: 'Upload multiple recipients',
      recipients: 'Recipients',
      how_to_use_gift_card: 'How to use gift card',
    },
  },
  am: {
    translation: {
      top_selling_products: 'Լավագույն վաճառք',
      new_arrivals: 'Վերջին ավելացված',
      companies: 'Ընկերություններ',
      similar_products: 'Այլ Ծառայություններ',
      buy: 'Գնել',
      bonus: 'Բոնուս',
      submit: 'Հաստատել',
      apply: 'Օգտագործել',
      cancel: 'Չեղարկել',
      view_more: 'Տեսնել ավելին',
      amd: 'դրամ',
      price: 'Գին',
      generate_qr: {
        sender_name: 'Ձեր անունը',
        sender_email: 'Ձեր էլ. հասցեն',
        sender_phone_number: 'Ձեր հեռախոսահամարը',
        personal: 'Իմ համար',
        recipient_name: 'Ստացողի անուն',
        recipient_email: 'Ստացողի էլ. հասցե',
        message: 'Մաղթանք',
        notify_at: 'Երբ ուղարկել',
        gift: 'Նվեր',
        for_me: 'Ինձ համար',
        send_now: 'Ուղարկել հիմա',
        recipient_phone_number: 'Ստացողի հեռախոսահամար',
        schedule: 'Ընտրել օր',
        is_anonymous: 'Անանուն',
      },
      create_gift_card: 'Ստեղծել նվեր քարտ',
      home: 'Գլխավոր',
      type: 'Տեսակ',
      event: 'Առիթ',
      events: 'Առիթներ',
      relationships: 'Ում համար',
      description: 'Նկարագրություն',
      company_info: 'Ընկերության մասին',
      company: 'Ընկերություն',
      address: 'Հասցե',
      phone: 'Հեռախոս',
      sign_up: 'Գրանցվել',
      sign_in: 'Մուտք',
      alrady_have_an_account: 'Գրանցված ե՞ք',
      create_account: 'Գրանցվել',
      name: 'Անուն',
      email: 'Էլ. հասցե',
      quantity: 'Քանակ',
      created_at: 'Ստեղծված է',
      password: 'Գաղտնաբառ',
      repeat_password: 'Կրկնել գաղտնաբառը',
      dont_have_an_account: 'Գրանցված չե՞ք',
      forgot_password: 'Մոռացել եմ գաղտնաբառը',
      log_out: 'Դուրս Գալ',
      are_you_sure_logout: 'Համոզվա՞ծ եք, որ ցանկանում եք դուրս գալ:',
      main_menu: 'Մենյու',
      sent_gift_cards: 'Ուղարկած նվեր քարտեր',
      received_gift_cards: 'Ստացած նվեր քարտեր',
      sent: 'Ուղարկած',
      received: 'Ստացած',
      show: 'Դիտել',
      gift_card: 'Նվեր քարտ',
      code: 'Կոդ',
      expires_at: 'Լրանում է',
      profile: 'Անձնական էջ',
      hero: {
        eyebrow: 'Հայաստանի առաջին էլեկտրոնային նվեր-քարտերի հարթակը',
        title: 'Ընտրիր նվեր-քարտը։ Ուղարկիր էլ. փոստով կամ SMS-ով։',
        subtitle:
          'Նվեր-քարտեր Հայաստանի ընկերություններից։ Ընտրիր ձևավորումը, գրիր մաղթանքը, և այն կհասնի էլ. փոստով կամ SMS-ով՝ անմիջապես կամ քո նշած օրը։',
        primary_cta: 'Դիտել նվեր-քարտերը',
        secondary_cta: 'Տեսնել ընկերությունները',
        proof_speed: 'Ընտրիր ձևավորումը, գրիր մաղթանքը և ուղարկիր էլ. փոստով կամ SMS-ով՝ անմիջապես կամ քո ընտրած օրը։',
        proof_partners: 'Վճարիր iDram-ով կամ Visa/Mastercard քարտով։ Որոշ գործընկերներ տալիս են բոնուս, որը կարող ես ծախսել հաջորդ քարտի վրա։',
        proof_valid: 'Ստացողը ստանում է նվեր-քարտ՝ կոդով և QR-ով, որը ցույց է տալիս գործընկեր ընկերությունում։',
        chip_delivery: 'Էլ. փոստ կամ SMS',
        chip_pay: 'iDram · Visa/Mastercard',
        chip_redeem: 'Կոդ և QR',
        art_alt:
          'Նվեր-քարտը վճարվում է, ուղարկվում էլ. փոստով կամ SMS-ով և ցուցադրվում գործընկերոջ մոտ՝ կոդով և QR-ով։',
      },
      sold_cards_lead: 'նվեր-քարտ արդեն վաճառվել է',
      sold_cards_body:
        'Յուրաքանչյուրը գնվել է egiftcards.am-ում և ուղարկվել էլ. փոստով կամ SMS-ով։',
      newsletter_body: 'Ստացիր նորություններ նոր ընկերությունների և առաջարկների մասին էլ. փոստով։',
      faq_lead: 'Պատասխաններ հաճախ տրվող հարցերին։',
      search: 'Փնտրել',
      menu: 'Մենյու',
      contact_lead: 'Գրեք մեզ չաթում կամ էլ. փոստով։ Պատասխանում ենք աշխատանքային օրերին։',
      become_a_partner_lead:
        'Պատմեք ձեր ընկերության մասին, և մենք կկապվենք ձեզ հետ նվեր-քարտերը հարթակում տեղադրելու համար։',
      request_company_lead:
        'Ընկերությունը բացակայո՞ւմ է։ Ասեք որը, և մենք կկապվենք նրանց հետ։',
      close: 'Փակել',
      filters: 'Զտիչներ',
      clear_filters: 'Մաքրել զտիչները',
      no_results: 'Այս զտիչներով նվեր-քարտեր չեն գտնվել',
      read_more: 'Կարդալ ավելին',
      view_all: 'Տեսնել բոլորը',
      sold_cards: 'Նվիրած քարտեր',
      sort_by: 'Դասավորել',
      price_desc: 'Ըստ գնի նվազող',
      price_asc: 'Ըստ գնի աճող',
      become_a_partner: 'Դառնալ գործընկեր',
      partnership: 'Համագործակցություն',
      request_company: 'Առաջարկել ընկերություն',
      first_name: 'Անուն',
      last_name: 'Ազգանուն',
      company_name: 'Ընկերության անունը',
      send_request: 'Կատարել Հարցում',
      contact: 'Կապ մեզ հետ',
      service: 'Ծառայություն',
      order_number: 'Պատվերի համարը',
      used_at: 'Օգտագործված է',
      used: 'Օգտագործված',
      not_used: 'Օգտագործված չէ',
      download: 'Ներբեռնել',
      new_gift_card: 'Նոր Նվեր-Քարտ',
      pay: 'Վճարում',
      continue: 'Շարունակել',
      summary: 'Ընդհանուր',
      e_gift_cards: 'Էլեկտրոնային Նվեր-Քարտեր',
      payment_successful: 'Վճարումը կատարված է',
      payment_message: 'Ուրախ ենք տեղեկացնել ձեզ, որ ձեր վճարումը հաստատվել է: Շնորհակալություն',
      payment_failed: 'Վճարումը ձախողվել է',
      payment_failed_message: 'Ձեր վճարումը չի կատարվել',
      yes: 'Այո',
      no: 'Ոչ',
      about_us: 'Մեր մասին',
      about_us_description: {
        title: 'Էլեկտրոնային Նվեր-Քարտերի հարթակ',
        convenience: 'Հարմարավետություն',
        speed: 'Արագություն',
        variety: 'Բազմազանություն',
        security: 'Անվտանգություն',
        lede:
          'Առցանց հարթակ թվային նվեր-քարտեր գնելու և վաճառելու համար՝ ինչպես գնորդների, այնպես էլ քարտերի հետևում կանգնած ընկերությունների համար։',
        what_title: 'Ի՞նչ է E-Gift Cards-ը',
        what_body_1:
          'E-Gift Cards-ը նորարարական առցանց հարթակ է, որը նախատեսված է թվային (digital) նվեր քարտեր գնելու և վաճառելու համար։ Մենք տրամադրում ենք հարմարավետ առցանց հարթակ ինչպես գնորդների, այնպես էլ վաճառողների համար՝ հեղափոխելով մարդկանց նվեր քարտերի տրամադրման և ստացման ձևը։',
        what_body_2:
          'Մենք հասկանում ենք ձեր սիրելիների համար կատարյալ նվեր գտնելու կարևորությունը։ Մեր հարթակի միջոցով դուք հասանելիություն եք ստանում հայկական ապրանքանիշերի թվային նվեր քարտերի լայն ընտրանիին։ Անկախ նրանից, թե դուք փնտրում եք ծննդյան նվեր, տոնական նվեր կամ պարզապես ցանկանում եք ուրախացնել մտերիմներին, մեր հարթակում հեշտությամբ կգտնեք այն։',
        fact_delivery_label: 'Առաքում',
        fact_delivery_value: 'Էլ. փոստով կամ SMS-ով',
        fact_payments_label: 'Վճարումներ',
        fact_payments_value: 'iDram, Visa/Mastercard',
        fact_brands_label: 'Ապրանքանիշեր',
        fact_brands_value: 'Հայկական ընկերություններ՝ մեծ և փոքր',
        why_title: 'Ինչու՞ ընտրել E-Gift Cards-ը',
        why_lede: 'Չորս բան, որոնց հետևում կանգնած ենք հարթակում վաճառվող յուրաքանչյուր քարտի համար։',
        convenience_body:
          'Մեր հարթակը վերացնում է ֆիզիկական նվեր քարտերի անհրաժեշտությունը՝ առաջարկելով թվային նվեր քարտեր, որոնք հասանելի են ցանկացած վայրից և ցանկացած ժամանակ։',
        speed_body:
          'Այլևս կարիք չկա այցելել խանութ սրահ՝ նվեր քարտ գնելու համար։ Ստացիր հասանելիություն նվեր քարտերի մեծ տեսականիին, մեկ հարթակում, և գնիր առանց տանից դուրս գալու, ցանկացած ժամի, ցանկացած երկրից։',
        variety_body:
          'Մենք ունենք նվեր քարտերի հսկայական հավաքածու, որը ներառում է հայտնի ապրանքանիշերի և փոքր ընկերությունների նվեր քարտերի բազմազան տեսականի։',
        security_body:
          'Մենք առաջնահերթություն ենք տալիս ձեր գործարքների անվտանգությանը՝ կիրառելով անվտանգության ամուր միջոցներ և գաղտնագրման արձանագրություններ։ Բոլոր նվեր քարտերը ունիկալ են և չեն կարող պատճենվել։',
        join_title: 'Միացե՛ք E-Gift Cards-ին այսօր',
        join_body:
          'Վայելեք թվային նվեր քարտերի գնումների հարմարավետությունն ու ճկունությունը։ Անկախ նրանից՝ դուք գնորդ եք, թե վաճառող, մենք ձգտում ենք ապահովել ապահով և հաճելի հարթակ, որը կբարձրացնի նվերների փորձը բոլոր ներգրավվածների համար։',
      },
      how_it_works: 'Ինչպե՞ս է աշխատում E-Gift Cards-ը',
      contact_us: 'Կապ մեզ հետ',
      online_business: 'Հայաստան — միայն օնլայն',
      online_business_note:
        'Մենք օնլայն բիզնես ենք և գործում ենք Հայաստանում։ Ֆիզիկական խանութ կամ գրասենյակ չունենք․ գրեք մեզ չաթում կամ էլ. փոստով։',
      live_chat: 'Օնլայն չաթ',
      start_chat: 'Սկսել զրույցը',
      where_we_work: 'Որտեղ ենք գործում',
      online_gift_cards: 'Օնլայն Նվեր-Քարտեր',
      services: 'Ծառայություններ',
      gift_cards: 'Նվեր Քարտեր',
      soon: 'Շուտով',
      showing_results: 'Ցուցադրված են {{firstItemNumber}}-{{lastItemNumber}}-ը {{total}}-ից',
      gift_card_is_valid_for: 'Նվեր-քարտը ուժի մեջ է {{expiresAt}} օր',
      online: 'Առցանց',
      sorry_page_not_found: 'Էջը չի գտնվել...',
      back_to_home: 'Վերադառնալ գլխավոր էջ',
      phone_number: 'Հեռախոսահամար',
      balance: 'Մնացորդ',
      messages: {
        become_a_partner_success: 'Ձեր հարցումը հաջողությամբ ընդունված է',
      },
      attention: 'Ուշադրություն`',
      enter_your_phone_number: 'Հաստատման համար` մուտքագրեք ձեր հեռախոսահամարը',
      preview: 'Նախադիտում',
      share: 'Կիսվել',
      available_bonus: 'Հասանելի բոնուս',
      privacy_policy: 'Գաղտնիության քաղաքականություն',
      terms_of_service: 'Պայմաններ և դրույթներ',
      agree_with_policy: `Ես կարդացել եմ և համաձայն եմ <privacyPolicy>Գաղտնիության քաղաքականության</privacyPolicy>
      {{and}}<termsOfService>Պայմանների ու դրույթների</termsOfService> հետ`,
      and: 'ու',
      special_offers: 'Հատուկ առաջարկներ',
      learn_more: 'Իմանալ ավելին',
      buyers_passport: 'Գնորդի անձնագիր',
      upload_images: 'Բեռնել նկարներ',
      coupon: 'Կուպոն',
      search_company: 'Փնտրել ընկերություն',
      name_desc: 'Ըստ անվան Ֆ-Ա',
      name_asc: 'Ըստ անվան Ա-Ֆ',
      starting_from: 'Սկսած',
      all_companies: 'Բոլորը',
      latest_companies: 'Վերջին ընկերությունները',
      faq: 'Հաճախ Տրվող Հարցեր',
      blog: 'Բլոգ',
      blog_description: 'Նվերների գաղափարներ, խորհուրդներ և նորություններ egiftcards.am-ից',
      no_articles_found: 'Դեռևս հոդվածներ չկան։',
      newsletter_subscription: 'Բաժանորդագրվեք մեր նորություններին',
      support: 'Սպասարկում',
      creating: {
        title: 'Ընտրիր և վճարիր',
        description:
          'Ընտրիր նվեր-քարտը, դրա ձևավորումը, գրիր մաղթանք ստացողի համար և վճարիր iDram-ով կամ Visa/Mastercard քարտով։',
      },
      receiving: {
        title: 'Առաքվում է էլ. փոստով կամ SMS-ով',
        description:
          'Քարտն ուղարկվում է PDF-ով էլ. փոստին կամ հղումով SMS-ով՝ վճարումից անմիջապես հետո կամ քո նշած օրը։',
      },
      happiness: {
        title: 'Օգտագործվում է գործընկերի մոտ',
        description:
          'Ստացողը ցույց է տալիս քարտի կոդը կամ QR-ը գործընկեր ընկերությունում, որը ստուգում է այն և նշում որպես օգտագործված։',
      },
      delete: 'Հեռացնել',
      edit: 'Խմբագրել',
      event_calendar: {
        title: 'Առիթ',
        description: 'Նկարագրություն',
        not_chosen: 'Չնշված',
        remind: {
          title: 'Հիշեցնել',
          day: '1 օր առաջ',
          week: '1 շաբաթ առաջ',
          month: '1 ամիս առաջ',
        },
        repeat: {
          title: 'Կրկնել',
          day: 'ամեն օր',
          month: 'ամեն ամիս',
          year: 'ամեն տարի',
        },
        celebrant_name: 'Հոբելյարի անուն',
        celebrant_email: 'Հոբելյարի էլ. հասցե',
        new_event: 'Նոր առիթ',
      },
      privacy_policy_content: privacy_policy_content_am,
      date: 'Ամսաթիվ',
      coupons: 'Կուպոններ',
      website: 'Վեբկայք',
      notes: 'Հավելյալ տեղեկություն',
      sale: 'Զեղչ',
      in_sale: 'Զեղչված',
      multiple_recipients: 'Մի քանի ստացող',
      upload: 'Վերբեռնել',
      upload_multiple_recipients: 'Վերբեռնել մի քանի ստացողներ',
      recipients: 'Ստացող',
      how_to_use_gift_card: 'Ինչպես օգտագործել նվեր քարտը',
    },
  },
  ru: {
    translation: {
      top_selling_products: 'Полулярное',
      new_arrivals: 'Новинки',
      companies: 'Компании',
      similar_products: 'Похожие сервисы',
      buy: 'Купить',
      submit: 'Отправить',
      apply: 'Применить',
      cancel: 'Отменить',
      view_more: 'Больше',
      amd: 'драм',
      price: 'Цена',
      bonus: 'Бонус',
      generate_qr: {
        sender_name: 'Имя отправителя',
        sender_email: 'Эл. почта отправителя',
        sender_phone_number: 'Номер телефона отправителя',
        personal: 'Личный',
        recipient_name: 'Имя получателя',
        recipient_email: 'Эл. почта получателя',
        message: 'Сообщение',
        notify_at: 'Уведомлять',
        gift: 'Подарок',
        for_me: 'Для меня',
        send_now: 'Отправить сейчас',
        schedule: 'Выбрать день',
        recipient_phone_number: 'Номер телефона получателя',
        is_anonymous: 'Анонимно',
      },
      create_gift_card: 'Создать подарочную карту',
      home: 'Домой',
      type: 'Тип',
      event: 'Событие',
      events: 'События',
      relationships: 'Для кого',
      description: 'Описание',
      company_info: 'Информация о компании',
      company: 'Компания',
      address: 'Адрес',
      phone: 'Телефон',
      sign_up: 'Регистрация',
      sign_in: 'Войти',
      alrady_have_an_account: 'Есть аккаунт?',
      create_account: 'Создать аккаунт',
      name: 'Имя',
      email: 'Эл. почта',
      quantity: 'Количество',
      created_at: 'Создан',
      password: 'пароль',
      repeat_password: 'Повторить пароль',
      dont_have_an_account: 'У вас еще нет аккаунта?',
      forgot_password: 'Забыли пароль',
      log_out: 'Выйти',
      are_you_sure_logout: 'Вы уверены, что хотите выйти?',
      main_menu: 'Меню',
      sent_gift_cards: 'Отправленные подарочные карты',
      sent: 'Отправленные',
      received: 'Полученные',
      received_gift_cards: 'Полученные подарочные карты',
      show: 'Показать',
      gift_card: 'Подарочная карта',
      code: 'Код',
      expires_at: 'Истекает',
      profile: 'Профиль',
      hero: {
        eyebrow: 'Первая платформа электронных подарочных карт в Армении',
        title: 'Выберите подарочную карту. Отправьте по email или SMS.',
        subtitle:
          'Подарочные карты от компаний по всей Армении. Выберите дизайн, напишите пожелание — карта придёт на email или по SMS сразу или в выбранный вами день.',
        primary_cta: 'Смотреть карты',
        secondary_cta: 'Смотреть компании',
        proof_speed: 'Выберите дизайн, напишите пожелание и отправьте по email или SMS — сразу или в выбранный день.',
        proof_partners: 'Оплата через iDram или картой Visa/Mastercard. Некоторые партнёры начисляют бонус на следующую покупку.',
        proof_valid: 'Получатель получает подарочную карту с кодом и QR, которые показывает у партнёра.',
        chip_delivery: 'Email или SMS',
        chip_pay: 'iDram · Visa/Mastercard',
        chip_redeem: 'Код и QR',
        art_alt:
          'Подарочная карта оплачивается, отправляется по email или SMS и предъявляется у партнёра по коду и QR.',
      },
      sold_cards_lead: 'подарочных карт уже продано',
      sold_cards_body:
        'Каждая куплена на egiftcards.am и отправлена по email или SMS.',
      newsletter_body: 'Получайте новости о новых компаниях и предложениях по email.',
      faq_lead: 'Ответы на частые вопросы.',
      search: 'Поиск',
      menu: 'Меню',
      contact_lead: 'Напишите нам в чат или на email. Отвечаем в рабочие дни.',
      become_a_partner_lead:
        'Расскажите о своей компании — мы свяжемся с вами по поводу размещения подарочных карт.',
      request_company_lead: 'Не хватает компании? Напишите какой — мы свяжемся с ней.',
      close: 'Закрыть',
      filters: 'Фильтры',
      clear_filters: 'Сбросить фильтры',
      no_results: 'По этим фильтрам подарочные карты не найдены',
      read_more: 'Читать далее',
      view_all: 'Смотреть все',
      sold_cards: 'Проданные подарочные карты',
      sort_by: 'Сортировать',
      price_desc: 'По убыванию цены',
      price_asc: 'По возрастанию цены',
      become_a_partner: 'Стать партнером',
      partnership: 'Сотрудничество',
      request_company: 'Предложить компанию',
      first_name: 'Имя',
      last_name: 'Фамилия',
      company_name: 'Название компании',
      send_request: 'Отправить запрос',
      contact: 'Свяжитесь с нами',
      service: 'Услуга',
      order_number: 'Номер',
      used_at: 'Использовалась',
      used: 'Использованный',
      not_used: 'Неиспользованный',
      download: 'Скачать',
      new_gift_card: 'Новая подарочная карта',
      pay: 'Оплата',
      continue: 'Продолжить',
      summary: 'Итого',
      e_gift_cards: 'Электронные подарочные карты',
      payment_successful: 'Оплата прошла успешно!',
      payment_message: 'Мы рады сообщить вам, что мы подтвердили ваш платеж. Спасибо!',
      payment_failed: 'Платеж не прошел',
      payment_failed_message: 'Ваш платеж не получен',
      yes: 'Да',
      no: 'Нет',
      about_us: 'О нас',
      about_us_description: {
        title: 'Платформа электронных подарочных карт',
        convenience: 'Удобство',
        speed: 'Скорость',
        variety: 'Разнообразие',
        security: 'Безопасность',
        lede:
          'Онлайн-платформа для покупки и продажи цифровых подарочных карт — для покупателей и для компаний, которые стоят за картами.',
        what_title: 'Что такое E-Gift Cards?',
        what_body_1:
          'E-Gift Cards — это инновационная онлайн-платформа для покупки и продажи цифровых подарочных карт. Мы предоставляем удобную онлайн-платформу как для покупателей, так и для продавцов, революционизируя способы дарения и получения подарочных карт.',
        what_body_2:
          'Мы понимаем, как важно найти идеальный подарок для ваших близких. Через нашу платформу вы получаете доступ к широкому выбору цифровых подарочных карт от армянских брендов. Если вы ищете подарок на день рождения, праздничный подарок или просто хотите порадовать своих близких, вы легко найдете его на нашей платформе.',
        fact_delivery_label: 'Доставка',
        fact_delivery_value: 'Email или SMS',
        fact_payments_label: 'Оплата',
        fact_payments_value: 'iDram, Visa/Mastercard',
        fact_brands_label: 'Бренды',
        fact_brands_value: 'Армянские компании, большие и небольшие',
        why_title: 'Почему E-Gift Cards?',
        why_lede: 'Четыре принципа, которым мы следуем для каждой карты на платформе.',
        convenience_body:
          'Наша платформа устраняет необходимость в физических подарочных картах, предлагая цифровые подарочные карты, доступные из любого места и в любое время.',
        speed_body:
          'Вам больше не нужно посещать магазин, чтобы купить подарочную карту. Получите доступ к большому выбору подарочных карт на одной платформе и покупайте, не выходя из дома, в любое время и в любой стране.',
        variety_body:
          'У нас есть огромная коллекция подарочных карт, которая включает в себя широкий выбор подарочных карт от известных брендов и небольших компаний.',
        security_body:
          'Мы уделяем первостепенное внимание безопасности ваших транзакций, внедряя надежные меры безопасности и протоколы шифрования. Все подарочные карты уникальны и не могут быть скопированы.',
        join_title: 'Присоединяйтесь к E-Gift Cards сегодня',
        join_body:
          'Наслаждайтесь удобством и гибкостью покупок цифровых подарочных карт. Являетесь ли вы покупателем или продавцом, мы стремимся предоставить безопасную и приятную платформу, которая расширяет возможности подарков для всех участников.',
      },
      how_it_works: 'Как это работает',
      contact_us: 'Свяжитесь с нами',
      online_business: 'Армения — только онлайн',
      online_business_note:
        'Мы онлайн-бизнес и работаем в Армении. У нас нет физического магазина или офиса — напишите нам в чат или на email.',
      live_chat: 'Онлайн-чат',
      start_chat: 'Начать чат',
      where_we_work: 'Где мы работаем',
      online_gift_cards: 'Электронные подарочные карты',
      services: 'Услуги',
      gift_cards: 'Подарочные карты',
      soon: 'Скоро',
      showing_results: 'Показаны {{firstItemNumber}}-{{lastItemNumber}} из {{total}}',
      gift_card_is_valid_for: 'Подарочная карта действительна {{expiresAt}} дней',
      online: 'Онлайн',
      sorry_page_not_found: 'Извините, мы не можем найти эту страницу...',
      back_to_home: 'На главную',
      phone_number: 'Номер телефона',
      balance: 'Баланс',
      messages: {
        become_a_partner_success: 'Ваш запрос успешно получен!',
      },
      attention: 'Внимание!',
      enter_your_phone_number: 'Для верификации введите ваш номер телефона',
      preview: 'Предварительный просмотр',
      share: 'Поделится',
      available_bonus: 'Доступные бонусы',
      privacy_policy: 'Политика Конфиденциальности',
      terms_of_service: 'Условия использования',
      agree_with_policy: `Согласен с <privacyPolicy>Политикой Конфиденциальности</privacyPolicy>
      {{and}}<termsOfService>Условиями использования</termsOfService>`,
      and: 'и',
      special_offers: 'Специальные предложения',
      learn_more: 'Узнать больше',
      buyers_passport: 'Паспорт покупателя',
      upload_images: 'Загрузить изображения',
      coupon: 'Купон',
      search_company: 'Искать компанию',
      name_desc: 'По названию Ю-А',
      name_asc: 'По названию А-Ю',
      starting_from: 'Цена от',
      all_companies: 'Показать все',
      latest_companies: 'Последние компании',
      faq: 'Часто Задаваемые Вопросы',
      blog: 'Блог',
      blog_description: 'Идеи подарков, советы и новости от egiftcards.am',
      no_articles_found: 'Статей пока нет.',
      newsletter_subscription: 'Подпишитесь на наши новости',
      support: 'Поддержка',
      creating: {
        title: 'Выберите и оплатите',
        description:
          'Выберите подарочную карту и её дизайн, напишите пожелание получателю и оплатите через iDram или картой Visa/Mastercard.',
      },
      receiving: {
        title: 'Доставка по email или SMS',
        description:
          'Карта отправляется в PDF на email или ссылкой по SMS — сразу после оплаты или в выбранный вами день.',
      },
      happiness: {
        title: 'Использование у партнёра',
        description:
          'Получатель показывает код или QR карты в компании-партнёре, которая проверяет её и отмечает как использованную.',
      },
      delete: 'Удалить',
      edit: 'Редактировать',
      event_calendar: {
        title: 'Событие',
        description: 'Описание',
        not_chosen: 'Не выбрано',
        remind: {
          title: 'Напоминание',
          day: 'За 1 день',
          week: 'За 1 неделю',
          month: 'За 1 месяц',
        },
        repeat: {
          title: 'Повтор',
          day: 'Каждый день',
          month: 'Каждый месяц',
          year: 'Каждый год',
        },
        celebrant_name: 'Именинник',
        celebrant_email: 'Эл. почта именинника',
        new_event: 'Новое событие',
        privacy_policy_content: privacy_policy_content_en,
        date: 'Дата',
        coupons: 'Купоны',
      },
      website: 'Веб-сайт',
      notes: 'Доп. информация',
      sale: 'Скидка',
      in_sale: 'Скидки',
      multiple_recipients: 'Несколько получателей',
      upload: 'Загрузить',
      upload_multiple_recipients: 'Загрузить несколько получателей',
      recipients: 'Получателей',
      how_to_use_gift_card: 'Как использовать подарочную карту',
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'am',
    returnNull: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
